export const isNotLoginRequired = (pathname: string) =>
  ["/login", "/reset-password", "/reset-password-new", "/session-expired"].some(row => pathname.startsWith(row));
